import { Injectable, inject } from "@angular/core";
import { AppState } from "app/shared/common/utils/AppState";
import { HttpHelper } from "app/shared/common/utils/http/HttpHelper";
import { Observable, map } from "rxjs";
import { IAgGridRowStatus } from "../ag-grid-without-cache/ag-grid-without-cache.model";

@Injectable({
  providedIn: 'root'
})
export class AgGridgroupService {
  private httpHelper: HttpHelper = inject(HttpHelper);
  private appState: AppState = inject(AppState);
  constructor() { }

  pivotPaging<T>(request: any, apiPivotPaging: string): Promise<T> {
    return this.httpHelper.methodPostService(apiPivotPaging, request);
  }

  pivotCount<T>(request: any, apiCount: string): Promise<T> {
    return this.httpHelper.methodPostService(apiCount, request);
  }

  pivotCountObservable(request: any, apiCount: string): Observable<any> {
    return this.httpHelper.methodPostObservableService(apiCount, request);
  }

  pivotPagingObservable(request: any, apiPivotPaging: string): Observable<any> {
    return this.httpHelper.methodPostObservableService(apiPivotPaging, request).pipe(map((res) => res?.data));
  }

  getUserAttribute(pageAttribute: string): Promise<any> {
    return this.appState.getAttributeValue(pageAttribute);
  }

  setUserAttribute(pageAttribute: string, atributeValue: string): Promise<any> {
    return this.appState.setAttributeValue(pageAttribute, atributeValue);
  }

  updateRowStatus(data: IAgGridRowStatus, apiUpDateRecordStatus: string): Promise<any> {
    return this.httpHelper.methodPostService(apiUpDateRecordStatus, data);
  }

}
